import axiosClient from "./axiosClient";
import { API_ENDPOINTS, API_CREDENTIALS } from "./apiEndpoints";

export const fetchToursDetails = ({ products_id }) => {
  // Construct query parameters
  // const params = {
  //   list_category_titles_and_ids,
  //   has_product_ids: has_product_ids.join(","), // Convert array to comma-separated string
  // };

  return axiosClient.get(API_ENDPOINTS.TOURS_DETAILS({ products_id }), {
    headers: {
      apikey: API_CREDENTIALS.API_KEY,
      "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
      apiconnection: "appmobile",
      lang: "en",
    },
  });
};

export const fetchToursDetailsAfterBooking = ({ products_id }) => {
  // Construct query parameters
  // const params = {
  //   list_category_titles_and_ids,
  //   has_product_ids: has_product_ids.join(","), // Convert array to comma-separated string
  // };

  return axiosClient.get(
    API_ENDPOINTS.TOURS_DETAILS_AFTER_BOOKING({ products_id }),
    {
      headers: {
        apikey: API_CREDENTIALS.API_KEY,
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        apiconnection: "appmobile",
        lang: "en",
      },
    }
  );
};
